import { envSchema } from './env.schema';

/**
 * Fail fast and loudly on a misconfigured build rather than at the first
 * Firebase call.
 *
 * This runs at module load, so importing this file requires a real
 * configuration. Anything that only needs the rules - a test, a tool - should
 * import ./env.schema instead.
 */
const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  const missing = parsed.error.issues.map((i) => i.path.join('.')).join(', ');
  // Developer-facing: this fires at module load, before any UI or locale
  // exists, so it stays in English rather than pretending to be translatable.
  throw new Error(
    `Incomplete configuration. Missing or invalid variables: ${missing}. ` +
      'Copy .env.example to web/.env.local and fill in the values.',
  );
}

export const env = parsed.data;
export const isDev = import.meta.env.DEV;
